import isACountry from '../isACountry';
import isCustomGroup from '../isCustomGroup';
import isRegularGroup from '../isRegularGroup';

/**
 * Returns the location type for a given code.
 * Types: 'country' | 'group' | 'custom-group'
 *
 * - Custom groups: codes generated via customGroupsService URL param (e.g. _abcd_Name_DZA_EGY)
 * - Regular groups: entries present in referenceData.regionCodes (e.g. g1)
 * - Countries: anything that is not a group or custom group
 */
export default function getLocationType(code) {
  if (isCustomGroup(code)) return 'custom-group';
  if (isRegularGroup(code)) return 'group';
  if (isACountry(code)) return 'country';
  // Fallback to 'group' for unknown codes to preserve previous behavior
  return 'group';
}
